import Vue from 'vue'
import axios from 'axios'

// Router
import router from '@/router/index'

// Vuex
import store from '../store'

// Event Bus
import EventBus from '@/services/EventBus'

Vue.prototype.$http = axios;

export default() => {
	const apiClient = axios.create({
    baseURL: process.env.API_URL + `/api/`,
    withCredentials: true,
		headers: {
			'content-type': 'application/json'
		}
	})

	/*apiClient.interceptors.response.use(undefined, (error) => {
      return new Promise(function (resolve, reject) {

        if (error.response.status === 401) {
          store.dispatch('user/logout').then(() => {
            router.push('/login')
          })
        }
        reject(error);
      })
    })*/

	return apiClient;
}


// WEBPACK FOOTER //
// ./src/services/Api.js